module.exports = __webpack_public_path__ + "static/media/newcard_sixmonths.a36f88a4.png";